<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";

interface UsageOperation {
  time: string;
  traffic: number;
  type: string;
  unit: string;
  amount: number | string;
  duration: number;
  callingNumber: string;
  dialedNumber: string;
  balance: number;
}

interface UsageOperationGroup {
  date: string;
  operations: UsageOperation[];
}

defineProps<{
  operations: UsageOperationGroup[];
  getOperationTitle: (op: UsageOperation) => string;
  getOperationSubtitle: (type: string) => string;
  getOperationValue: (op: UsageOperation) => string;
  getOperationMeta: (op: UsageOperation) => string;
}>();

const { t } = useI18n();

const typeIconHistory = (opType: string) => {
  if (opType == "SMS") return "mail";
  else if (
    opType === "Голосовая связь" ||
    opType === "Голосовая связь международная"
  )
    return "phoneretro";
  else return "earth";
};
</script>

<template>
  <div class="history-body__details">
    <div v-if="!operations.length" class="history-body__details-empty">
      <div class="history-body__details-empty_title">
        <p class="caption-medium color-text-secondary">
          {{ t("history.empty") }}
        </p>
      </div>
    </div>
    <div v-else class="history-body__details-list">
      <div
        v-for="(day, index) in operations"
        :key="index"
        class="history-body__details-list_item"
      >
        <div class="history-body__details-list_day">
          <p class="h3 color-grey-light">{{ day.date }}</p>
        </div>
        <div
          v-for="(op, idx) in day.operations"
          :key="idx"
          class="history-body__details-list_info"
        >
          <BaseFigureForIcon
            class="history-body__details-list_icon"
            :icon="`${typeIconHistory(op.type)}`"
            color="grey-full"
            radius="16px"
            size="large"
          />
          <div class="history-body__details-list_title">
            <p class="h4">{{ getOperationTitle(op) }}</p>
            <p class="caption-small color-text-secondary">
              {{ getOperationSubtitle(op.type) }}
            </p>
          </div>
          <div class="history-body__details-list_numbers">
            <p class="h3">{{ getOperationValue(op) }}</p>
            <p class="caption-small color-text-secondary">
              {{ getOperationMeta(op) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/history-operations";
</style>
